export default __webpack_public_path__ + "static/media/step2-section3.ff6668bd.png";